module.exports = __webpack_public_path__ + "static/media/eth.2263176f.svg";